import { useEffect, type ReactNode } from 'react'
import { createActorContext } from '@xstate/react'
import { mapTooltipMachine } from '~/machines/mapTooltipMachine'
import { registerMapTooltipActor } from '~/util/mapTooltipActorBridge'

const DEBUG = false
export const MapTooltipMachineContext = createActorContext(mapTooltipMachine, {
  inspect: (e) => {
    if (DEBUG && e.type === '@xstate.event') {
      console.log(e.event)
    }
  },
})

function MapTooltipActorRegistration() {
  const actorRef = MapTooltipMachineContext.useActorRef()

  useEffect(() => {
    return registerMapTooltipActor(actorRef)
  }, [actorRef])

  return null
}

export function MapTooltipMachineProvider({ children }: { children: ReactNode }) {
  return (
    <MapTooltipMachineContext.Provider>
      <MapTooltipActorRegistration />
      {children}
    </MapTooltipMachineContext.Provider>
  )
}
